export default "__VITE_ASSET__DHnm2a2r__"